module.exports = __webpack_public_path__ + "static/media/LogicWedge2_3_drag_4.61b67690.png";